import { z } from 'zod';
import { TypeOfAPIError, TypeOfAPIResponse } from '@ninja/api-client';
import { APIFactoryOptions, factory } from '../../../config';

const questionAnswersSchema = z.object({
	questionId: z.number(),
	answerId: z.number(),
	answer: z.string(),
});

const membersAnswersSchema = z.array(
	z.object({
		memberId: z.string(),
		height: z.number(),
		weight: z.number(),
		isMedicalConditionDeclared: z.boolean(),
		questionAnswers: z.array(questionAnswersSchema),
		userAcknowledgementId: z.number().optional(),
	})
);

const responseSchema = z.object({
	encryptedJourneyId: z.string(),
	isSuccess: z.boolean(),
});

const saveMedicalQuestionAnswer = (options: APIFactoryOptions) =>
	factory(options).createAPIDefinition({
		url: '/Member/:journeyId/save-medical-question-answer',
		method: 'POST',
		responseSchema: responseSchema,
		requestSchema: membersAnswersSchema,
		requestParameters: { journeyId: ['required', 'string'] },
	});

export default saveMedicalQuestionAnswer;

export type SaveMedicalQuestionAnswerRequest = z.infer<typeof responseSchema>;

export type SaveMedicalQuestionAnswerResponse = TypeOfAPIResponse<ReturnType<typeof saveMedicalQuestionAnswer>>;

export type SaveMedicalQuestionAnswerError = TypeOfAPIError<ReturnType<typeof saveMedicalQuestionAnswer>>;
